function menopauseChangeTab(clickedControl, tabIndex) {
  const doctorsSection = clickedControl.closest('.app-doctors-section.menopause-template');

  if (!doctorsSection) {
    return;
  }

  doctorsSection.querySelectorAll('[data-tab-index]').forEach((control) => {
    control.classList.toggle('active', Number(control.dataset.tabIndex) === tabIndex);
  });

  doctorsSection.querySelectorAll('.content-section').forEach((content, index) => {
    content.classList.toggle('active', index === tabIndex - 1);
  });

  doctorsSection.querySelectorAll('.doctor-image').forEach((image, index) => {
    const isActive = index === tabIndex - 1;
    image.classList.toggle('active', isActive);
    image.style.display = isActive ? 'block' : 'none';
  });
}

document.querySelectorAll('.app-doctors-section.menopause-template').forEach((doctorsSection) => {
  const firstTab = doctorsSection.querySelector('.tab');

  if (firstTab) {
    menopauseChangeTab(firstTab, 1);
  }
});
